import { useState } from 'react';
import content from '../content.json';
const pub = process.env.PUBLIC_URL;

function Lightbox({ photos, index, onClose, onPrev, onNext }) {
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 9999, background: 'rgba(0,0,0,0.95)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <img src={`${pub}/${photos[index]}`} alt="" onClick={e => e.stopPropagation()} style={{ maxWidth: '90vw', maxHeight: '85vh', objectFit: 'contain' }} />
      {photos.length > 1 && <>
        <button onClick={e=>{e.stopPropagation();onPrev();}} style={{ position:'absolute',left:'20px',top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'white',fontSize:'36px',opacity:0.6,transition:'opacity 0.2s' }} onMouseEnter={e=>e.currentTarget.style.opacity=1} onMouseLeave={e=>e.currentTarget.style.opacity=0.6}>‹</button>
        <button onClick={e=>{e.stopPropagation();onNext();}} style={{ position:'absolute',right:'20px',top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'white',fontSize:'36px',opacity:0.6,transition:'opacity 0.2s' }} onMouseEnter={e=>e.currentTarget.style.opacity=1} onMouseLeave={e=>e.currentTarget.style.opacity=0.6}>›</button>
      </>}
      <button onClick={onClose} style={{ position:'absolute',top:'20px',right:'28px',background:'none',border:'none',cursor:'pointer',color:'white',fontSize:'24px',opacity:0.6 }} onMouseEnter={e=>e.currentTarget.style.opacity=1} onMouseLeave={e=>e.currentTarget.style.opacity=0.6}>✕</button>
      <div style={{ position:'absolute',bottom:'20px',left:'50%',transform:'translateX(-50%)',fontFamily:'var(--font-body)',fontSize:'11px',letterSpacing:'0.15em',color:'rgba(255,255,255,0.4)' }}>{index+1} / {photos.length}</div>
    </div>
  );
}

function RoomCard({ room, index }) {
  const [photo, setPhoto] = useState(0);
  const [lb, setLb] = useState(null);
  const isComingSoon = room.id === 'ska003';

  if (isComingSoon) return (
    <div className="reveal" style={{ background: '#b5835a', padding: '80px 48px', textAlign: 'center', minHeight: '300px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <span style={{ fontFamily:'var(--font-body)',fontSize:'10px',letterSpacing:'0.3em',textTransform:'uppercase',color:'rgba(255,255,255,0.7)',display:'block',marginBottom:'16px' }}>Coming Soon</span>
      <h3 style={{ fontFamily:'var(--font-title)',fontSize:'2.2rem',color:'white' }}>{room.name}</h3>
    </div>
  );

  return (
    <>
      <div className="reveal" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', background: index % 2 === 0 ? '#ffffff' : 'var(--offwhite)', border: '1px solid #ece8e0' }}>
        {/* Photo side */}
        <div style={{ position: 'relative', overflow: 'hidden', cursor: 'pointer', height: '380px' }} onClick={() => setLb(photo)}>
          <img src={`${pub}/${room.photos[photo]}`} alt={room.name} style={{ width:'100%',height:'100%',objectFit:'cover',transition:'transform 0.5s ease' }}
            onMouseEnter={e=>e.target.style.transform='scale(1.04)'} onMouseLeave={e=>e.target.style.transform='scale(1)'}
          />
          <div style={{ position:'absolute',bottom:'12px',left:'50%',transform:'translateX(-50%)',display:'flex',gap:'5px' }}>
            {room.photos.map((_,i) => (
              <button key={i} onClick={e=>{e.stopPropagation();setPhoto(i);}} style={{ width:i===photo?'18px':'4px',height:'1px',background:i===photo?'white':'rgba(255,255,255,0.4)',border:'none',cursor:'pointer',transition:'all 0.3s',padding:0 }} />
            ))}
          </div>
        </div>
        {/* Info side */}
        <div style={{ padding: '48px 40px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <div>
            <span style={{ fontFamily:'var(--font-body)',fontSize:'10px',letterSpacing:'0.25em',textTransform:'uppercase',color:'var(--gold)',display:'block',marginBottom:'8px' }}>{room.tagline}</span>
            <h3 style={{ fontFamily:'var(--font-title)',fontSize:'2rem',color:'var(--text)',marginBottom:'4px' }}>{room.name}</h3>
            <div style={{ width:'32px',height:'1px',background:'var(--gold)',margin:'16px 0' }} />
            <p style={{ fontFamily:'var(--font-body)',fontSize:'13px',lineHeight:1.8,color:'var(--text2)',marginBottom:'24px' }}>{room.description}</p>
            <div style={{ display:'flex',flexWrap:'wrap',gap:'8px',marginBottom:'28px' }}>
              {room.amenities.slice(0,6).map((a,i) => (
                <span key={i} style={{ fontFamily:'var(--font-body)',fontSize:'10px',letterSpacing:'0.08em',textTransform:'uppercase',color:'var(--text2)',border:'1px solid #ddd',padding:'3px 9px' }}>{a}</span>
              ))}
            </div>
          </div>
          <div style={{ display:'flex',alignItems:'center',justifyContent:'space-between' }}>
            <div>
              <span style={{ fontFamily:'var(--font-body)',fontSize:'10px',color:'var(--text2)',letterSpacing:'0.1em',textTransform:'uppercase' }}>from </span>
              <span style={{ fontFamily:'var(--font-title)',fontSize:'2rem',color:'var(--gold)' }}>€{room.price}</span>
              <span style={{ fontFamily:'var(--font-body)',fontSize:'11px',color:'var(--text2)' }}>/night</span>
            </div>
            <a href="#contact" style={{ fontFamily:'var(--font-body)',fontSize:'10px',letterSpacing:'0.2em',textTransform:'uppercase',color:'white',background:'var(--dark)',padding:'12px 24px',transition:'opacity 0.2s' }}
              onMouseEnter={e=>e.target.style.opacity='0.8'} onMouseLeave={e=>e.target.style.opacity='1'}
            >Book Now</a>
          </div>
        </div>
      </div>
      {lb !== null && <Lightbox photos={room.photos} index={lb} onClose={()=>setLb(null)} onPrev={()=>setLb((lb-1+room.photos.length)%room.photos.length)} onNext={()=>setLb((lb+1)%room.photos.length)} />}
    </>
  );
}

export default function Rooms() {
  return (
    <section id="rooms" style={{ background: 'var(--offwhite)', padding: '100px 0' }}>
      <div style={{ maxWidth: '1160px', margin: '0 auto', padding: '0 48px' }}>
        <div className="reveal" style={{ textAlign: 'center', marginBottom: '60px' }}>
          <span className="section-label">Indulge in design and cosiness with our boutique accommodations</span>
          <h2 className="section-title">Discover the SKA studios</h2>
          <div className="gold-line center" />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {content.rooms.map((room, i) => <RoomCard key={room.id} room={room} index={i} />)}
        </div>
      </div>
    </section>
  );
}
